export default __webpack_public_path__ + "static/media/hacktiv-navbar.35edca5f.png";